// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TabProps } from "@insite/mobius/Tab";
import { xBaseTheme } from "@steiner/XDL/types";
import { color, styledScrollbar } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            weight: "bold",
            color: "common.white",
            css: css`
                letter-spacing: 0;
                line-height: 18px;
            `,
        },
        css: css`
            position: relative;
            padding: 4px 20px;
            cursor: pointer;
            background: ${color("primary")};
            border: 1px solid ${color("common.ui3")};
            min-width: 220px;

            &:hover {
                background: ${color("common.ui9")};
                border: 1px solid ${color("common.ui3")};
            }

            &:focus {
                outline: none;
            }

            ${({ selected }: TabProps) =>
                selected &&
                css`
                    background: ${color("common.ui10")};
                `}
        `,
    },
    groupDefaultProps: {
        mergeCss: true,
        cssOverrides: {
            tabGroup: css`
                padding: 0 2px 2px 0;
                position: relative;

                &:after {
                    content: "";
                    position: absolute;
                    display: block;
                    background-color: ${color("common.ui3")};
                    bottom: 2px;
                    left: 0;
                    right: 0;
                    height: 1px;
                    width: 100%;
                    z-index: -1;
                }

                ${styledScrollbar()}
            `,
            tabContent: css`
                position: relative;
                margin-top: 0;
                padding: 12px 0 5px;
                border-top: 0;
                border-bottom: 0;
            `,
            wrapper: css`
                width: 100%;
                padding: 0;
            `,
        },
    },
} as xBaseTheme["tab"];
